

const Def = () => {
  return (
    <div id='def'>
      <div className='container flex align-start'>
        <div className='about flex flex-col align-start gap-16'>
          <h2>Gr8 <b>Appers</b></h2>
          <p className='mdText'>An exceptional applicant — one who stands out because of clarity, confidence, and preparation, powered by intelligent insights.</p>
        </div>
        <div className='noun'>
          <h3 className='flex gap-8 align-center'>Apper <small>-</small><small>noun</small></h3>
          <p className='mdText'>/ˈæpər/</p>
        </div>
      </div>
    </div>
  );
};

export default Def;